import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "./TreatmentPlanList.css";
import { getPatientTreatmentPlan, getPatientMedicationPlan } from "../services/patientService";
import { toast } from "react-toastify";
import CustomPagination from "../../Common/Component/CustomPagination/CustomPagination";
import { useNavigate } from "react-router-dom";
import Loader from "../../utils/Loader";

export default function TreatmentPlanPatient({ patient }) {
  const navigate = useNavigate();
  const [patientTreatmentPlan, setPatientTreatmentPlan] = useState([]);
  const [patientMedicationPlan, setPatientMedicationPlan] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedValue, setSelectedValue] = useState("");
  const [loading, setLoading] = useState(false);

  /* Function's */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchPatientMedicationPlanById(selectedValue)
  }, [page, limit]);

  const fetchPatientTreatmentPlanById = async (eventKey) => {
    try {
      const response = await getPatientTreatmentPlan({ patientId: patient, page: page + 1, limit, searchKey: searchText, sortBy: eventKey });
      if (response?.status === "SUCCESS") {
        setPatientTreatmentPlan(response?.data?.list);
        setTotalPages(response?.data?.totalPages || 0);
        setTotalItems(response?.data?.totalItems || 0);
      }
    } catch (error) {
      toast.error("Please try again later");
    }
  };

  const fetchPatientMedicationPlanById = async (eventKey) => {
    try {
      setLoading(true)
      const response = await getPatientMedicationPlan({ patientId: patient, page: page + 1, limit, searchKey: searchText, sortBy: eventKey });
      if (response?.status === "SUCCESS") {
        setPatientMedicationPlan(response?.data.list);
        setTotalPages(response?.data?.totalPages || 0);
        setTotalItems(response?.data?.totalItems || 0);
      }
      setLoading(false)

    } catch (error) {
      setLoading(false)
      toast.error("Please try again later");
    }
  };

  const handleSelect = (eventKey) => {
    setSelectedValue(eventKey); // Update the state with the selected value
    fetchPatientMedicationPlanById(eventKey);
  };

  return (
    <>
      {
        loading && <Loader />
      }

      <div className="Dashboard-lft-blk">

        <div className="lft-blk-top d-flex justify-content-between mb-3">
          <h2>&nbsp;</h2>

          <div className="dropdowns-here d-flex gap-2">
            <Dropdown className="patient-info-dropdown d-flex text-center aling-item-center" onSelect={handleSelect}>
              <Dropdown.Toggle className="db-dropdown">
                {selectedValue === "" ? "Sort By" : (selectedValue === 'recent' ? "recent" : "oldest")}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item eventKey="recent">Recent</Dropdown.Item>
                <Dropdown.Item eventKey="oldest">Oldest</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        {/* table for tratment lis  */}
        <div className="table-responsive dashboard-table">
          <table className="patients-table">
            <thead>
              <tr className="t-row-block">
                <th scope="col">Sr No</th>
                <th scope="col">Medicine Name</th>
                <th scope="col">Medication Type</th>
                <th scope="col">Medication Strength</th>
                <th scope="col">Frequency Per Day</th>
              </tr>
            </thead>
            <tbody>
              {patientMedicationPlan.length > 0 ? (
                patientMedicationPlan?.map((patient, index) => (
                  <tr key={patient.id || index}>
                    <td scope="row" style={{ borderLeft: '0px' }}>
                      {++index}
                    </td>
                    <td>
                      {patient.medicationName}
                    </td>
                    <td>
                      {patient.medicationType}

                    </td>
                    <td style={{ borderRight: '0px' }}>
                      {patient.medicationStrength} {patient.medicationUnit}

                    </td>

                    <td style={{ borderRight: '0px' }}>
                      {patient?.reminderTime.length || "--"}

                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No medication Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="pagination-blk">
          <CustomPagination
            totalItems={totalItems}
            page={page}
            onPageChange={handleChangePage}
            limit={limit}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  )
}    
